import { InstallPage } from '../../shared/ui';
import { OtherInstallCopy } from './components/OtherInstallCopy';
import styles from './PwaInstallOther.module.css';

export function PwaInstallOther() {
  return (
    <InstallPage className={styles.root}>
      <OtherInstallCopy />
    </InstallPage>
  );
}
